import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { AccountFacade } from 'ish-core/facades/account.facade';
import { CheckoutFacade } from 'ish-core/facades/checkout.facade';
import { FeatureToggleService } from 'ish-core/feature-toggle.module';

import { CrossSellingPopupService } from '../services/cross-selling-popup.service';

/**
 * Extended CheckoutFacade that filters basketChange$ to prevent mini-basket from opening
 * when the cross-selling popup is visible
 */
@Injectable({ providedIn: 'root' })
export class ExtendedCheckoutFacade extends CheckoutFacade {
  private crossSellingPopupService = inject(CrossSellingPopupService);
  private featureToggleService = inject(FeatureToggleService);

  constructor(store: Store, accountFacade: AccountFacade) {
    super(store, accountFacade);

    // Override basketChange$ to filter out events when cross-selling popup is visible
    const originalBasketChange$ = this.basketChange$;
    this.basketChange$ = this.featureToggleService.enabled$('crossSellingPopup').pipe(
      switchMap(isFeatureEnabled => {
        if (!isFeatureEnabled) {
          // If CrossSellingPopup feature is not enabled, show mini cart as usual
          return originalBasketChange$;
        }
        // If feature is enabled, filter out events when cross-selling popup is visible
        return originalBasketChange$.pipe(
          withLatestFrom(this.crossSellingPopupService.crossSellingPopup$),
          filter(([_, popupEvent]) => !popupEvent), // Don't emit if cross-selling popup is visible
          map((): void => undefined)
        );
      })
    );
  }
}
